import { cn } from '../utils'

interface AvatarProps {
  name: string
  photoUrl?: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
}

const sizeStyles = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-7 w-7 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((n) => n[0] ?? '')
    .join('')
    .toUpperCase()
}

// Um só neutro (7,6:1 com texto branco). A paleta anterior — tons 500 por
// nome — ficava entre 2,1:1 (âmbar) e 4,5:1, e a cor não identificava nada.
function getAvatarColor(_name: string): string {
  return 'bg-slate-600'
}

export function Avatar({ name, photoUrl, size = 'md', className }: AvatarProps) {
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={cn('rounded-full object-cover ring-2 ring-white', sizeStyles[size], className)}
      />
    )
  }

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full font-semibold text-white',
        sizeStyles[size],
        getAvatarColor(name),
        className,
      )}
    >
      {getInitials(name)}
    </span>
  )
}
